import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Input } from 'components/atoms/input';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';

const StyledInput = styled(Input)`
  margin-top: var(--spacing-03);
`;

export const EmailField: FC<FormFieldProps> = ({
  field,
  control,
  setValue,
  errors,
  disabled,
}) => {
  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <Controller
        control={control}
        rules={{
          required: field.required,
          validate: {
            invalidEmail: (value) =>
              value ? /\S+@\S+\.\S+/.test(value) : true,
          },
        }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <StyledInput
            bordered={false}
            disabled={disabled}
            ref={props.field.ref}
            value={props.field.value}
            onChange={(e) =>
              setValue?.(field.questionId.toString(), e.target.value)
            }
          />
        )}
      />
      <FieldsErrorRenderer errors={errors} questionId={field.questionId} />
      <FormItemDesc label={field.description} />
    </FormItemWrapper>
  );
};
